(function($){
    function activateTab(number) {
        $(".teamCarousel").slick('unslick');

        $(".tabs__navItem").removeClass('tabs__navItem--active');
        $(".tabs__content").removeClass('tabs__content--active');

        $(".tabs__content[data-tab-id=" + number + "]").addClass('tabs__content--active');
        $(".tabs__navItem[data-tab-id=" + number + "]").addClass('tabs__navItem--active');

        $('.tabs__content--active .teamCarousel').slick();
    }

    if ($(".tabs").length) {
        $(".tabs__navItem").click(function(event) {
            event.preventDefault();

            var number = $(this).attr('data-tab-id');

            activateTab(number);
        });
    }
}(jQuery));